import { Injectable } from '@angular/core';
import { THEME_COOKIE_NAME } from '@core/theme/domain/domain';

/** Read-only view of the theme preference cookie.
 *
 * READ-ONLY on purpose: the product apps own this preference (the Sytex back's
 * `/api/theme/` endpoint writes it, scoped to the shared `sytex.io` domain) and this
 * app has no theme picker. Writing from here would let a pre-auth surface overwrite
 * a preference it has no authority over.
 */
@Injectable({
  providedIn: 'root'
})
export class ThemeCookieStorageService {
  read(): string | undefined {
    const pattern = new RegExp(`(?:^|;\\s*)${THEME_COOKIE_NAME}=([^;]*)`);
    const match = document.cookie.match(pattern);
    if (!match) {
      return undefined;
    }
    return decodeURIComponent(match[1]);
  }
}
